import { render, staticRenderFns } from "./productSearchSwitchTab.vue?vue&type=template&id=795fa98a&"
import script from "./productSearchSwitchTab.vue?vue&type=script&lang=js&"
export * from "./productSearchSwitchTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
